import { getFrontendBootstrap } from '@atlassian/mpac-api-client';
import { StatsigContext } from '@atlassian/mpac-feature-flags';
import { useContext, useEffect, useState } from 'react';
import { getCloudIdFromHostInfo } from '../../../services/HostInfoApi';
import { getApplicationConfigForEnv } from '../../../utils/common-utils';
/**
 * This hook is designed to initialize the Statsig client for touchpoints
 * that are outside of the EMCEE environment, such as install dialogs or
 * request dialogs that are initialized separately from EMCEE.
 *
 * If the hook is used within EMCEE, where the Statsig client is already
 * initialized, it will act as a no-op, ensuring that no redundant
 * initialization occurs.
 *
 */
export const useInitialiseStatsigIfNeeded = _ref => {
  let {
    currentUser,
    hostInfo,
    environment
  } = _ref;
  const statsigContext = useContext(StatsigContext);
  const [isClientInitialised, setIsClientInitialised] = useState(false);
  async function fetchMarketplaceAnonymousId() {
    try {
      const data = await getFrontendBootstrap();
      return data.launchDarklyUserKey;
    } catch (error) {
      console.error('Failed to fetch frontend bootstrap:', error);
    }
  }
  const statsigMarketplaceInstance = statsigContext.statsigClient.getMarketplaceClientInstance();
  async function initialiseClient() {
    const marketplaceAnonymousId = await fetchMarketplaceAnonymousId();
    const applicationConfig = getApplicationConfigForEnv(environment);
    const statsigConfig = applicationConfig.statsig;
    if (statsigContext.statsigClient && !statsigMarketplaceInstance && statsigConfig && marketplaceAnonymousId && hostInfo) {
      const tenantId = getCloudIdFromHostInfo(hostInfo) || '';
      const atlassianAccountId = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.atlassianAccountId) || '';
      const {
        clientKey,
        environment: featureGateEnvironment,
        targetApp
      } = statsigConfig;
      await statsigContext.statsigClient.initializeStatsigClient({
        clientKey,
        environment: featureGateEnvironment,
        targetApp,
        tenantId,
        atlassianAccountId,
        marketplaceAnonymousId
      }, {
        targetApp,
        tenantId,
        atlassianAccountId,
        cloudId: tenantId,
        userAgent: navigator.userAgent,
        hostProduct: hostInfo.product
      }, 'PRODUCT');
      await statsigContext.statsigClient.updateIdentifiers({
        marketplaceAnonymousId
      });
      setIsClientInitialised(true);
    }
  }
  useEffect(() => {
    if (hostInfo) {
      if (statsigContext.statsigClient.getIsStatsigInitialized()) {
        setIsClientInitialised(true);
      } else if (!statsigMarketplaceInstance) {
        initialiseClient();
      }
    }
  }, [statsigMarketplaceInstance, hostInfo, statsigContext.statsigClient.getIsStatsigInitialized()]);
  return {
    isClientInitialised,
    statsigContext
  };
};